import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "../../../../Common/UI/Index";
import { ButtonVariantType } from "../../../../Common/UI/Types";
import Add from "~icons/ic/baseline-add-circle";
import "./Style.scss";

interface CreateOutputConfigViewProps {
  /**
   * @returns Click action on add new config button
   */
  OnAddNewOutputConfig: () => void;
}

/**
 * Responsible for rendering the output config button view
 */
export const CreateOutputConfigView: React.FC<CreateOutputConfigViewProps> = (props: CreateOutputConfigViewProps) => {
  const { OnAddNewOutputConfig } = props;
  const { t: translate } = useTranslation();

  return (
    <div
      className="ebt-output-config__add-btn"
      id="ebt-outputConfig-add-btn"
    >
      <Button
        variant={ButtonVariantType.FILLED}
        onClick={OnAddNewOutputConfig}
        id="ebt-outputConfig-add-btn"
      >
        <Add title="Add" />
        {translate("Button.OutputConfiguration")}
      </Button>
    </div>
  );
};
